<template>
  <div>
    <div class="d-flex flex-column-fluid">
      <div class="container">
        <div class="d-flex flex-row">
          <div class="flex-row-auto offcanvas-mobile w-250px w-xxl-350px">
            <div class="card card-custom card-stretch">
              <div class="card-body pt-4">
                <div class="d-flex align-items-center">
                  <span class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
                    <img v-if="user.downloadUrl" alt="Pic" :src="user.downloadUrl" />
                    <span v-else class="symbol-label font-size-h5 font-weight-bold">
                      {{user.empChar}}
                    </span>
                  </span>
                  <div>
                    <a href="#" class="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary">{{user.userName}}</a>
                  </div>
                </div>
                <div class="pt-3 navi navi-bold navi-hover navi-active navi-link-rounded">
                  <div class="navi-item mb-2">
                    <a class="navi-link py-4 active">
                      <span class="svg-icon svg-icon-xl navi-icon mr-2"><inline-svg class="svg-icon" src="media/svg/icons/General/User.svg"/></span>
                      <span class="navi-text font-size-lg">{{$t('ACCOUNT.Account_Information')}}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-row-fluid ml-lg-8">
            <div class="card card-custom">
              <div class="card-header py-3">
                <div class="card-title align-items-start flex-column">
                  <h3 class="card-label font-weight-bolder text-dark">{{$t('ACCOUNT.Account_Information')}}</h3>
                  <span class="text-muted font-weight-bold font-size-sm mt-1">{{$t('ACCOUNT.Change_your_account_settings')}}</span>
                </div>
                <div class="card-toolbar">
                  <button class="btn btn-success" v-on:click="saveInfo">{{$t('ACCOUNT.Save_Changes')}}</button>
                </div>
              </div>
              <form class="form">
                <div class="card-body">
                  <div class="row">
                    <label class="col-xl-3"></label>
                    <div class="col-lg-9 col-xl-6">
                      <h5 class="font-weight-bold mb-6">{{$t('ACCOUNT.Account')}}:</h5>
                    </div>
                  </div>
                  <div class="form-group row align-items-center">
                    <label class="col-xl-3 col-lg-3 col-form-label">{{$t('USER.Avatar')}}</label>
                    <div class="col-lg-9 col-xl-6">
                      <div class="image-input image-input-outline">
                        <div class="image-input-wrapper"></div>
                        <label class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="change" data-toggle="tooltip" title="" data-original-title="Change avatar">
                          <i class="fa fa-pen icon-sm text-muted"></i>
                          <input type="file" name="profile_avatar" accept=".png, .jpg, .jpeg" v-on:change="uploadFile"/>
                          <input type="hidden" name="profile_avatar_remove" />
                        </label>
                        <span class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="cancel" data-toggle="tooltip" title="Cancel avatar">
															<i class="ki ki-bold-close icon-xs text-muted"></i>
														</span>
                      </div>
                      <span class="form-text text-muted">{{ $t('ACCOUNT.Upload_pictures') }}</span>
                    </div>
                  </div>
                  <div class="form-group row align-items-center">
                    <label class="col-xl-3 col-lg-3 col-form-label"><span class="text-danger">*</span>&nbsp;{{$t('ACCOUNT.Fullname')}}</label>
                    <div class="col-lg-9 col-xl-6">
                      <input type="text" class="form-control form-control-lg form-control-solid" v-model="user.userName"/>
                    </div>
                  </div>
                  <div class="form-group row align-items-center">
                    <label class="col-xl-3 col-lg-3 col-form-label">{{$t('ACCOUNT.gender')}}</label>
                    <div class="col-lg-9 col-xl-6">
                      <select class="form-control form-control-lg form-control-solid" v-model="user.gender">
                        <option value=""></option>
                        <option value="1">{{$t('ONLINE.male')}}</option>
                        <option value="2">{{$t('ONLINE.female')}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row align-items-center">
                    <label class="col-xl-3 col-lg-3 col-form-label">{{$t('ACCOUNT.Email')}}</label>
                    <div class="col-lg-9 col-xl-6">
                      <input type="text" class="form-control form-control-lg form-control-solid" v-model="user.email"/>
                    </div>
                  </div>
                  <div class="form-group row align-items-center">
                    <label class="col-xl-3 col-lg-3 col-form-label">{{$t('ACCOUNT.corporation')}}</label>
                    <div class="col-lg-9 col-xl-6">
                      <input type="text" class="form-control form-control-lg form-control-solid" v-model="user.companyName"/>
                    </div>
                  </div>
                  <div class="form-group row align-items-center">
                    <label class="col-xl-3 col-lg-3 col-form-label">{{$t('ACCOUNT.Address')}}</label>
                    <div class="col-lg-9 col-xl-6">
                      <input type="text" class="form-control form-control-lg form-control-solid" v-model="user.contractAdress"/>
                    </div>
                  </div>
                  <div class="form-group row align-items-center">
                    <label class="col-xl-3 col-lg-3 col-form-label">{{$t('ACCOUNT.Linkman')}}</label>
                    <div class="col-lg-9 col-xl-6">
                      <input type="text" class="form-control form-control-lg form-control-solid" v-model="user.linkman"/>
                    </div>
                  </div>
                  <div class="form-group row align-items-center">
                    <label class="col-xl-3 col-lg-3 col-form-label">{{$t('ACCOUNT.phone')}}</label>
                    <div class="col-lg-9 col-xl-6">
                      <input type="text" class="form-control form-control-lg form-control-solid" v-model="user.phone"/>
                    </div>
                  </div>
                  <div class="form-group row align-items-center">
                    <label class="col-xl-3 col-lg-3 col-form-label">{{$t('ACCOUNT.industry')}}</label>
                    <div class="col-lg-9 col-xl-6">
                      <input type="text" class="form-control form-control-lg form-control-solid" v-model="user.industry"/>
                    </div>
                  </div>
                  <div class="form-group row align-items-center">
                    <label class="col-xl-3 col-lg-3 col-form-label">{{$t('ACCOUNT.webUrl')}}</label>
                    <div class="col-lg-9 col-xl-6">
                      <input type="text" class="form-control form-control-lg form-control-solid" v-model="user.webUrl"/>
                    </div>
                  </div>
                  <div class="form-group row align-items-center">
                    <label class="col-xl-3 col-lg-3 col-form-label">{{$t('ACCOUNT.Language')}}</label>
                    <div class="col-lg-9 col-xl-6">
                      <div class="checkbox-inline">
                        <template v-for="(item, i) in languages">
                          <label class="checkbox checkbox-outline checkbox-success" :key="i" v-on:click="selectedLanguage(item.lang)">
                            <input type="checkbox" name="checkbox" :checked="isActiveLanguage(item.lang)"/>
                            <span></span>
                            {{item.name}}
                          </label>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import i18nService from "@/core/services/i18n.service";
import {SETAUTH} from "@/core/services/store/auth.module";
import store from "@/core/services/store";
export default {
  data() {
    return {
      languages: i18nService.languages,
    };
  },
  computed: {
    user: {
      get () {
        return this.$store.getters.currentUser;
      }
    },
    activeLanguage() {
      return i18nService.getActiveLanguage();
    }
  },
  methods: {
    selectedLanguage(languageVal) {
      i18nService.setActiveLanguage(languageVal);
      window.location.reload();
    },
    isActiveLanguage(current) {
      return this.activeLanguage === current;
    },
    saveInfo() {
      if (this.user && this.user.recordId){
        if (!this.user.userName){
          alert(this.$t('AUTH.VALIDATION.FULLNAME'));
          return;
        }
        this.user.cloud = "3";
        const _this = this;
        this.$axios.fetchPost("hr/user/saveInfo",this.user).then(result => {
          if(result.data.recordId){
            _this.getUser();
            alert(this.$t('ONLINE.Save_successfully'));
          }
        }).catch(err => {console.log(err);});
      }else {
        alert(this.$t('Please_refresh_and_retry'));
      }
    },
    getUser() {
      this.$axios.fetchPost("hr/user/getUser", this.user).then(result => {
        if(result.data.recordId && result.data.groupManageId && result.data.defaultDb){
          store.dispatch(SETAUTH, result.data);
        }
      }).catch(err => {console.log(err);});
    },
    uploadFile: function (file) {
      if (this.user && this.user.recordId) {
        const f = file.target.files[0]
        const type = ['image/jpg', 'image/jpeg', 'image/png']
        if (f && type.indexOf(f.type) >= 0) {
          // 通过form表单进行提交
          const param = new FormData()
          param.append('file', f)
          param.append('id', this.user.recordId)
          this.$axios.formPost('hr/user/uploadFile', param).then((data) => {
            if (data.data) {
              if (data.data === 'have') {
                alert(this.$t('ONLINE.The_file_name_has_been_uploaded'))
              } else if (data.data === 'false') {
                alert(this.$t('ONLINE.Upload_failed_please_refresh_and_try_again'))
              } else if (data.data === 'success') {
                alert(this.$t('ONLINE.Upload_successfully'))
              }
              this.$router.push({ name: "login" })
            } else {
              alert(this.$t('ONLINE.System_error'))
            }
          }).catch(err => {
                console.log(err)
              }
          )
        } else {
          alert(this.$t('ONLINE.Upload_only')+'jpg/jpeg/png'+this.$t('ONLINE.File_name_extension'))
        }
      } else {
        alert(this.$t('ONLINE.Please_log_in'))
      }
    }
  }
}
</script>